import Vue from 'vue'
import vuex, {Store} from 'vuex'
import menu from './menu'
import seoBigData from './seoBigData'
import noFollow from './noFollow'
import badLink from './badLink'
import baiduSite from './baiduSite'
import baiduRank from './baiduRank'
import mouseBaiduRank from './mouseBaiduRank'
import prohibitedWords from './prohibitedWords'
import popup from './popup'
import message from './message'
import vedio from './vedio'
import header from './header'
import user from './user'
import outlink from './outlink'
import sofasniper from './sofasniper'
import checkicp from './checkicp'
import checkICPInfo from './checkICPInfo'

Vue.use(vuex);

/**
 * 返回工厂模式
 * @returns {Store<>}
 */
export default () => new Store({
  modules: {
    menu,
    seoBigData,
    noFollow,
    badLink,
    baiduSite,
    baiduRank,
    mouseBaiduRank,
    prohibitedWords,
    popup,
    message,
    vedio,
    header,
    user,
    outlink,
    sofasniper,
    checkicp,
    checkICPInfo
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js